import { EventParams } from 'types/Analytics';

export const getBannerClickPayload = (url: EventParams['banner_click']['url'] = ''): EventParams['banner_click'] => ({
  url,
});
